import "./interface.scss";

import PropTypes from "prop-types";
import React from "react";

import keyConstants from "../../constants/keyConstants";
import onPulseAnimationEnd from "../onPulseAnimationEnd";
import { withOptionalTooltip } from "./Tooltip";

const Icon = props => {
  const onKeyDown = e => {
    if (e.key === keyConstants.Enter && props.onClick) {
      e.stopPropagation();
      e.preventDefault();
      props.onClick(e);
    }
  };

  const className = `icon ${props.className ? props.className : ""} ${props.pulse ? "pulse" : ""} ${
    props.color ? props.color : ""
  }`;
  const icon = (
    <div
      className={className}
      onClick={props.onClick}
      id={props.id ? props.id : null}
      onAnimationEnd={onPulseAnimationEnd}
      tabIndex={props.canFocus && props.onClick ? 0 : null}
      onKeyDown={onKeyDown}
    >
      <svg className={props.color ? props.color : ""}>
        <use xlinkHref={"#" + props.icon} />
      </svg>
    </div>
  );

  return withOptionalTooltip(icon, props.tooltip, { placement: "auto" });
};

Icon.defaultProps = {
  canFocus: true
};

Icon.propTypes = {
  icon: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  pulse: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
  canFocus: PropTypes.bool
};

export default Icon;
